import { render, staticRenderFns } from "./Wallpapers.vue?vue&type=template&id=17b972c2&scoped=true"
import script from "./Wallpapers.vue?vue&type=script&lang=js"
export * from "./Wallpapers.vue?vue&type=script&lang=js"
import style0 from "./Wallpapers.vue?vue&type=style&index=0&id=17b972c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b972c2",
  null
  
)

export default component.exports